<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vs-col vs-w="9">
		<div id="data-list-list-view" class="data-list-container">
			<vs-table
				ref="table"
				pagination
				:max-items="itemsPerPage"
				:data="actionListFilteredResults"
			>
				<div
					slot="header"
					class="flex flex-wrap-reverse items-center flex-grow justify-between"
				>
					<div
						class="flex flex-wrap-reverse items-center data-list-btn-container"
					>
						<!-- ACTION - DROPDOWN -->
						<vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-5">
							<a class="a-icon" href="#">
								Actions
								<vs-icon class="" icon="expand_more"></vs-icon>
							</a>
							<vs-dropdown-menu>
								<vs-dropdown-item @click="emailOffers()">
									<span class="flex items-center">
										<feather-icon
											icon="MailIcon"
											svgClasses="h-4 w-4"
											class="mr-2"
										/>
										<span>Send offer(s)</span>
									</span>
								</vs-dropdown-item>

								<vs-dropdown-item>
									<span class="flex items-center">
										<feather-icon
											icon="BellIcon"
											svgClasses="h-4 w-4"
											class="mr-2"
										/>
										<span>Activate alert(s)</span>
									</span>
								</vs-dropdown-item>

								<vs-dropdown-item>
									<span class="flex items-center">
										<feather-icon
											icon="XIcon"
											svgClasses="h-4 w-4"
											class="mr-2"
										/>
										<span>Deactivate alert(s)</span>
									</span>
								</vs-dropdown-item>

								<vs-dropdown-item>
									<span class="flex items-center">
										<feather-icon
											icon="HeartIcon"
											svgClasses="h-4 w-4"
											class="mr-2"
										/>
										<span>Mark as favorite(s)</span>
									</span>
								</vs-dropdown-item>
								<vs-dropdown-item>
									<span class="flex items-center">
										<feather-icon
											icon="XIcon"
											svgClasses="h-4 w-4"
											class="mr-2"
										/>
										<span>Unselect favorite(s)</span>
									</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
						<feather-icon
								v-if="actionFilter.alert"
								v-bind:svgClasses="{'h-6 w-6 stroke-current': true,}"
								class="cursor-pointer"
								icon="SettingsIcon"
								@click="settingsPromptDummy.activeAlertSettings = true"
							/>
					</div>

					<vs-prompt

					:active.sync="settingsPromptDummy.activeAlertSettings"
							title="Configure Alert"

					>
					<div class="con-exemple-prompt" style="width: auto">

						Cabin
						<ul class="flex flex-no-wrap my-3 mb-6">
            				<li class="mr-4">
								<vs-radio v-model="settingsPromptDummy.cabinAlertSettings" vs-value="1" >Interior</vs-radio>
            				</li>
            				<li class="mr-4">
								<vs-radio v-model="settingsPromptDummy.cabinAlertSettings" vs-value="2" >Oceanview</vs-radio>
            				</li>
            				<li class="mr-4">
								<vs-radio v-model="settingsPromptDummy.cabinAlertSettings" vs-value="3" >Balcony</vs-radio>
            				</li>
            				<li class="mr-4">
								<vs-radio v-model="settingsPromptDummy.cabinAlertSettings" vs-value="4" >Suite</vs-radio>
            				</li>
						</ul>

						<vs-checkbox v-model="settingsPromptDummy.priceUp" class="mx-0 my-3">Price up</vs-checkbox>

						<vs-checkbox v-model="settingsPromptDummy.soldOut" class="mx-0 my-3">Sold out</vs-checkbox>

						<vs-checkbox v-model="settingsPromptDummy.onSaleAgain" class="mx-0 my-3 mb-6">On sale again</vs-checkbox>

						Budget
						<vs-input icon-pack="feather" icon="icon-dollar-sign" icon-after v-model="settingsPromptDummy.budget" vs-placeholder="6100" class="mb-6" />

						<!-- <div class="vx-row">
							<div class="vx-col w-full">
								<vs-input v-validate="'required'" name="title" class="w-full mb-4 mt-5" placeholder="Title" />
								<vs-textarea rows="5" label="Add description" />
							</div>
						</div> -->

						<vs-checkbox v-model="settingsPromptDummy.dtc"  class="mx-0 my-2">Send alerts directly to Kate</vs-checkbox>

					</div>
					</vs-prompt>

					<div class="flex flex-wrap-nowrap">
						<vx-tooltip
							text="Alert list"
							position="bottom"
							delay=".3s"
							class="ml-6"
						>
							<!-- optimization: use 'text-grey' if filter would show no results -->
							<feather-icon
								v-bind:svgClasses="{
									'h-6 w-6 stroke-current': true,
									'text-primary': actionFilter.alert,
									'': !actionFilter.alert,
								}"
								class="cursor-pointer"
								icon="BellIcon"
								@click.stop="
									toggleAlertFilterView
								"
							/>
						</vx-tooltip>
						<vx-tooltip
							text="Favorite list"
							position="bottom"
							delay=".3s"
							class="ml-6"
						>
							<!-- optimization: use 'text-grey' if filter would show no results -->
							<feather-icon
								v-bind:svgClasses="{
									'h-6 w-6 stroke-current': true,
									'text-primary': actionFilter.like,
									'': !actionFilter.like,
								}"
								class="cursor-pointer"
								icon="HeartIcon"
								@click.stop="
									toggleLikeFilterView
								"
							/>
						</vx-tooltip>
					</div>
				</div>

				<template slot="thead">
					<vs-th />
					<vs-th sort-key="tripName" class="pl-0">Trip</vs-th>
					<vs-th sort-key="shipName">Cruise Ship</vs-th>
					<vs-th sort-key="date">Departure</vs-th>
					<vs-th sort-key="matchingScore">Matching</vs-th>
					<vs-th sort-key="priceChangePercent">Price (change)</vs-th>
					<vs-th>Email Sent</vs-th>
					<vs-th>Action</vs-th>
				</template>

				<template slot-scope="{ data }">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td class="xpl-2" style="position: relative">
									<!-- <feather-icon
										v-bind:svgClasses="{
											'h-6 w-6 stroke-current': true,
											'text-primary': tr.important,
											'text-warning': !tr.important,
										}"
										class="cursor-pointer"
										icon="MailIcon"
										@click.stop="tr.important = !tr.important"
									/> -->

								<div class="con-vs-checkbox mx-0 my-2 vs-checkbox-primary
											fake-checkbox vs-checkbox-default"
											v-bind:class="{'checked':tr.important}"
											v-on:click.stop.prevent="tr.important = !tr.important"
											>
									<!-- <input type="checkbox" class="vs-checkbox--input" v-model="tr.important"> -->
									<span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
										<span class="vs-checkbox--check">
											<i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i>
										</span>
									</span>
								</div>

							</vs-td>
							<vs-td class="pl-0">
								<p class="product-name font-medium truncate">
									{{ tr.tripName }}
								</p>
							</vs-td>

							<vs-td class="truncate">
								<p class="product-category flex items-center">
									<img :src="tr.cruiseLineLogo" class="mr-2" width="20" height="20">
									{{ tr.shipName }}
								</p>
							</vs-td>

							<vs-td>
								<p class="product-category">{{ tr.date }}</p>
							</vs-td>
							<vs-td>
								<vs-progress
									:percent="Number(tr.matchingScore)"
									:color="getPopularityColor(Number(tr.matchingScore))"
									class="shadow-md mr-3"
									style="min-width: 80px; width: 66%"
								/><span class="whitespace-no-wrap">{{ Math.round(Number(tr.matchingScore)) }} %</span>
							</vs-td>

							<vs-td class="truncate">
								<span class="product-price">${{ tr.totalPrice }}</span>
								(
								<i
									class="feather"
									v-bind:class="{
										'icon-arrow-down': tr.priceChangePercent < 0,
										'icon-arrow-up': tr.priceChangePercent > 0,
									}"
								></i>
								<span class="product-price">{{ tr.priceChangePercent }}%</span>
								)
							</vs-td>
							<vs-td class="whitespace-no-wrap" style="width:8%">
								<vx-tooltip
									text="Email sent"
									position="bottom"
									delay=".3s"
									class="inline-block"
                  v-if="tr.action.email"
								>
							<feather-icon
										v-bind:svgClasses="{
											'h-6 w-6 stroke-current': true,
											'text-primary': true,
										}"
										class="cursor-pointer"
										icon="MailIcon"
									/>
								</vx-tooltip>
							</vs-td>
							<vs-td class="whitespace-no-wrap">
								<div class="flex flex-wrap-nowrap">
									<vs-switch
										color="primary"
										v-model="tr.action.alert"
										@click.stop
										icon-pack="feather"
										vs-icon="icon-bell"
										class="mr-4"
									/>
									<vs-switch
										color="primary"
										v-model="tr.action.like"
										@click.stop
										icon-pack="feather"
										vs-icon="icon-heart"
									/>
								</div>
							</vs-td>

							<template slot="expand">
								<cat-cruise-details :result="tr" />
							</template>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
		</div>
	</vs-col>
</template>

<script>
import CatCruiseDetails from '@/components/cat/CruiseDetails.vue'

export default {
  props: {
    results: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      required: true
    }
  },
  components: {
    CatCruiseDetails
  },
  data () {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 15,
      isMounted: false,


    settingsPromptDummy: {
      activeAlertSettings: false,
      cabinAlertSettings: {},
      priceUp: false,
      priceDown: false,
      onSaleAgain: false,
      budget: 6100
    },

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},

      actionFilter: {
        email: null,
        like: null,
        alert: null
      }
    }
  },
  computed: {
    actionListFilteredResults () {
      const actionFilter = this.actionFilter
      let that = this;
      return this.results.filter(function (row) {
        // action: email, alert, like filter
        //console.log(actionFilter);
        return (
          (actionFilter.email === null || row.action.email) &&
					(actionFilter.like === null || row.action.like) &&
					(actionFilter.alert === null || row.action.alert)
        )
      }).map(function(row) {
        row.filter = that.filter;
        return row;
      })
    },
    cruises () {
      return this.$store.state.dataList.cruises
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.cruises.length
    }
  },
  methods: {
    getPopularityColor (num) {
      if (num > 80) return 'rgb(228, 74, 127)'
      if (num >= 50) return 'rgb(241, 157, 186)'
      if (num >= 25) return 'rgb(244, 178, 200)'
      return '#e2e2e2'
    },
    toggleAlertFilterView () {
      this.actionFilter.alert = this.actionFilter.alert ? null : true
      this.actionFilter.like = null
    },
    toggleLikeFilterView () {
      this.actionFilter.like = this.actionFilter.like ? null : true
      this.actionFilter.alert = null
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    emailOffers () {
      this.results.map(function (r) {
        if (r.important) {
          r.action.email = true
          r.important = false
        } return r
      })
      this.$vs.notify({
        title:'Success',
        text:'E-Mail with offers has been sent!',
        color:'success'})
    }
  },
  mounted () {
    if (this.filter.kkiAlertList) {
      for (let i = 0; i < 2; i++) {
        this.results[i].action.alert = true
        this.results[i].matchingScore = 99 - 5*i;
      }
      this.actionFilter.alert = true
    }
    if (this.filter.kkiBudgetAlert) {
      for (let i = 0; i < 2; i++) {
        this.results[i].totalPrice = 2499 - 500*i;
        this.results[i].priceChangePercent = -32 +12*i;
        this.results[i].mustBookNow = true;
      }
    }
    if (this.filter.kkiPriceAlert) {
      for (let i = 0; i < 2; i++) {
        this.results[i].totalPrice = 3300 - 400*i;
        this.results[i].priceChangePercent = -32 +12*i;
        this.results[i].mustBookNow = false;
      }
    }
  }
}
</script>

<style lang="scss">

</style>

